<template>
  <div class="home">
    <resetPassword/>
  </div>
</template>

<script>
// @ is an alias to /src
import resetPassword from '@/components/login/resetPassword'

export default {
  name: 'Reset',
  components: {
    resetPassword
  },
}
</script>
